import { defineStore } from 'pinia'
import axios from 'axios'

export const SearchStore = defineStore('Search', {
  state: () => ({
    query: {
      searchTerm: '',
      searchMode: '',
      date: 0,
      categoryId: 0,
      typeId: 0,
      pageNumber: 1,
      resultsPerPage: 12
    },
    filterOptions: {
      dates: [],
      categories: [],
      types: [],
    },
    type: '',
    apiName: '',
    queryStatus: 'loading',
    totalNumberOfResults: 0,
    items: [],
    filterOptionsStatus: 'loading',
    urlParametersStatus: 'loading',
    siteUrl: '',
    submitInnerHtml: ''
  }),
  actions: {
    async setSearchType(type) {
      this.type = type
      switch (type) {
        case 'pages':
          this.apiName = 'pagesapi'
          break;
        case 'articles':
          this.apiName = 'articlesapi'
          break;
        case 'events':
          this.apiName = 'eventsapi'
          break;
        case 'medwatch':
          this.apiName = 'medwatchapi'
          break;
        case 'chpnewsroom':
          this.apiName = 'chpnewsroomapi'
          break;
      }
      if (window.siteUrl != "") {
        this.siteUrl = window.siteUrl;
      }
    },
    async getFilterOptions() {
      try {
        this.filterOptionsStatus = 'loading'
        const response = await axios.get(`${this.siteUrl}/webapi/${this.apiName}/filteroptions`)
        this.filterOptions = response.data
        this.filterOptionsStatus = 'ready'
        return { success: true }
      }
      catch {
        this.filterOptionsStatus = 'error'
        return { success: false, messages: ['An unexpected error occurred.'] }
      }
    },
    async getResultsFromQuery() {
      try {
        this.queryStatus = 'loading'
        this.toggleFields(false);
        const response = await axios.post(`${this.siteUrl}/webapi/${this.apiName}/query`, this.query)
        this.items = response.data.results
        this.totalNumberOfResults = response.data.totalNumberOfResults
        this.queryStatus = 'ready'
        this.toggleFields(true);
        this.updateUrlParametersFromQuery()
        return { success: true }
      } catch {
        this.queryStatus = 'error'
        this.toggleFields(true);
        return { success: false, messages: ['An unexpected error occurred.'] }
      }
    },
    async toggleFields(enabledTrue_disabledFalse) {
      let input = document.getElementById('searchPageSearchTerm');
      let button = input.closest('form').querySelector('button[type="submit"]');
      if (enabledTrue_disabledFalse) {
        input.removeAttribute('disabled');
        input.nextElementSibling.removeAttribute('disabled');
        input.parentElement.removeAttribute('style');
        button.innerHTML = this.submitInnerHtml;
      } else {
        input.setAttribute('disabled', 'disabled');
        input.nextElementSibling.setAttribute('disabled', 'disabled');
        input.parentElement.setAttribute('style', 'background-color:#e9ecef');
        this.submitInnerHtml = button.innerHTML;
        button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="visually-hidden">Loading...</span>';
      }
    },
    async updateSearch(searchTerm, date, categoryId, typeId) {
      this.query.pageNumber = 1
      this.items = []
      this.query.searchTerm = searchTerm
      this.query.date = date
      this.query.categoryId = categoryId
      this.query.typeId = typeId
      await this.getResultsFromQuery()
    },
    async updatePageNumber(pageNumber) {
      this.query.pageNumber = pageNumber
      await this.getResultsFromQuery()
    },
    async updateQueryFromUrlParameters() {
      this.urlParametersStatus = 'loading'
      const urlParameters = new URLSearchParams(window.location.search)
      if (urlParameters.has('q')) {
        this.query.searchTerm = urlParameters.get('q')
      }
      if (urlParameters.has('mode')) {
        this.query.searchMode = urlParameters.get('mode')
      }
      if (urlParameters.has('date')) {
        this.query.date = parseInt(urlParameters.get('date'))
      }
      if (urlParameters.has('categoryid')) {
        this.query.categoryId = parseInt(urlParameters.get('categoryid'))
      }
      if (urlParameters.has('type')) {
        switch (urlParameters.get('type')) {
          case 'article':
            this.query.typeId = 1
            break;
          case 'video':
            this.query.typeId = 2
            break;
          default:
        }
      }
      this.urlParametersStatus = 'ready'
    },
    async updateUrlParametersFromQuery() {
      const urlParameters = new URLSearchParams()
      if (this.query.searchTerm) {
        urlParameters.append('q', this.query.searchTerm)
      }
      if (this.query.searchMode) {
        urlParameters.append('mode', this.query.searchMode)
      }
      if (this.query.date) {
        urlParameters.append('date', this.query.date)
      }
      if (this.query.categoryId) {
        urlParameters.append('categoryid', this.query.categoryId)
      }
      if (this.query.typeId) {
        switch (this.query.typeId) {
          case 1:
            urlParameters.append('type', 'article')
            break;
          case 2:
            urlParameters.append('type', 'video')
            break;
          default:
        }
      }
      const newUrl = new URL(window.location)
      newUrl.search = urlParameters.toString()
      window.history.replaceState(null, '', newUrl)
    },
  }
})
